module.exports = __webpack_public_path__ + "/b23aa16ea896864ada06f7dec1aa4df8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/gmail_logo.svg
 ** module id = 1643
 ** module chunks = 0
 **/